import { Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { formatDateUtc } from "@bw/shared/utils";
import type { LeagueDiscoveryItem } from "@bw/shared/types/generated";

export function LeagueOfferingFacts({
  offering,
}: {
  offering: LeagueDiscoveryItem;
}) {
  return (
    <Stack spacing={0.75}>
      <Typography>{offering.season_name}</Typography>
      <Typography color="text.secondary">
        {offering.facility_name} ·{" "}
        {[offering.city, offering.state].filter(Boolean).join(", ")}
      </Typography>
      <Typography variant="body2">
        {formatDateUtc(offering.start_date)} –{" "}
        {formatDateUtc(offering.end_date)}
      </Typography>
      <Typography variant="body2">
        {offering.league_format.replaceAll("_", " ")} ·{" "}
        {offering.min_tier ?? "Any level"}
        {offering.max_tier ? ` – ${offering.max_tier}` : ""}
      </Typography>
      <Typography variant="body2">
        {offering.registration_count}/{offering.max_players} registered ·{" "}
        {offering.registration_state}
      </Typography>
      <Link
        component={RouterLink}
        to={`/rankings?facility_id=${encodeURIComponent(offering.facility_id)}`}
        aria-label={`Rankings at ${offering.facility_name}`}
        variant="body2"
      >
        Facility rankings
      </Link>
      <Typography variant="caption" color="text.secondary">
        Payment is not collected online.
      </Typography>
    </Stack>
  );
}
